import { oz } from '@weft/utils';

export const InvoiceDateSchema = oz.object({ month: oz.string(), year: oz.number() }); 

export type InvoiceDate = oz.infer<typeof InvoiceDateSchema>;